<template>
  <ion-app>
    <ion-router-outlet />
  </ion-app>
</template>

<style>
.transmodal .modal-wrapper {
  --background: transparent;
}

.modal-fullscreen {
  --width: 100%;
  --height: 100%;
  --border-radius: none;
}
</style>

<script>
import { IonApp, IonRouterOutlet, useBackButton } from "@ionic/vue";
import { defineComponent, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Plugins } from "@capacitor/core";

export default defineComponent({
  name: "App",
  components: {
    IonApp,
    IonRouterOutlet,
  },
  async created() {
    const { App, Browser, Toast, Storage } = Plugins;

    console.log("App created");

    App.removeAllListeners();

    App.addListener("appUrlOpen", (data) => {
      console.log("appUrlOpen:", JSON.stringify(data));
      Browser.close();
      if (data.url.indexOf("verificationId=") > 0) {
        const token = data.url.split("verificationId=").pop();
        this.$store.commit("auth_update_recaptcha", token);
      } else {
        const slug = data.url.split("//").pop();

        if (slug) {
          this.$router.push({
            path: "/" + slug,
          });
        }
      }
    });

    const router = useRouter();
    const route = useRoute();
    const exitRequest = ref(false);

    useBackButton(9999, async () => {
      // const modal = await modalController.getTop()
      // if (modal) { // do nothing if a modal is open
      //   return;
      // }
      // if (route.path.match(/^\/auth\//i)) {
      //   return;
      // }
      if (route.path.match(/^\/tabs\//i) || route.path.match(/^\/preconds/i)) {
        if (exitRequest.value == true) {
          App.exitApp();
        } else {
          exitRequest.value = true;
          await Toast.show({
            text: "Nhấn lần nữa để thoát",
            duration: "short",
            position: "bottom",
          });
          setTimeout(() => {
            exitRequest.value = false;
          }, 2000);
        }
        return;
      }
      // console.log('goback');
      // router.back();
    });

    setTimeout(async () => {
      const channelCountStore = await Storage.get({
        key: "notification_count",
      });
      const channelCount = channelCountStore
        ? parseInt(channelCountStore.value) || 0
        : 0;
      this.$store.commit("notification_count", channelCount);
    }, 100);

    window.addEventListener("message", this.onMessage);
  },
  methods: {
    onMessage(e) {
      if (!e.data) return;

      let data = null;

      try {
        data = JSON.parse(e.data);
      } catch (error) {
        return;
      }

      if (!data.game) return;
      if (!data.payload) return;

      // validate payload first

      this.$router.push("/"+ data.game +"?payload=" + encodeURI(JSON.stringify(data.payload)));
    },
  },
});
</script>
